import React, {useState} from "react";
import ShenaiWidget from "./ShenaiWidget";
import AlulaWidget from "./AlulaWidget";
import {useAuth} from "react-oidc-context";
import {useViewport} from "react-viewport-hooks";
import {composeUrl} from "../../utils/api";
import LoadingSpinner from "../Shared/LoadingSpinner/LoadingSpinner";

enum ScanProviders {
    Alula = "Alula",
    Shenai = "Shenai",
}

interface FaceScanProviderProps {
    apiName: string;
    apiToken: string;
}

function Home() {
    
    const auth = useAuth();
    const {vw} = useViewport();
    
    const [loading, setLoading] = useState<boolean>(true);
    const [scanProvider, setScanProvider] = useState<string | undefined>();
    const [apiToken, setApiToken] = useState<string>("");
    
    React.useEffect(() => {
        const selectFaceScanProvider = async () => {
            
            try {
                setLoading(true);
                const params = new URLSearchParams();
                params.append("organisationId", `${auth.user?.profile.lime_organisation_uuid}`);
                const response = await fetch(composeUrl(`v1/healthTracker/GetFaceScanProvider?${params}`),{
                    headers: [
                        ["Authorization", `Bearer ${auth.user?.access_token}`],
                        ["Content-Type", "application/json"]
                    ],
                    method: "GET",
                });
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const result: FaceScanProviderProps = await response.json();
                setScanProvider(result.apiName);
                setApiToken(result.apiToken);
                setLoading(false);
            } catch (error) {
                console.error("There was a problem with the fetch operation:", error);
            }
        };
        selectFaceScanProvider();
    }, []);
    
    let layout;
    if (vw <= 1024 && vw >= 768) {
        layout = 'tablet';
    } else if (vw < 768) {
        layout = 'mobile';
    } else {
        layout = 'desktop';
    }
    
    return (
        <LoadingSpinner loading={loading}>
            {
                (scanProvider === ScanProviders.Shenai)  ?
                 (
                    <ShenaiWidget userId={auth.user?.profile.email} shenAiToken={apiToken} />

                ) :
                (
                    <AlulaWidget />
                )
            }
        </LoadingSpinner>
    );
}

export default Home;